import { render, staticRenderFns } from "./terminais_tef.vue?vue&type=template&id=52d808d5&scoped=true&"
import script from "./terminais_tef.vue?vue&type=script&lang=js&"
export * from "./terminais_tef.vue?vue&type=script&lang=js&"
import style0 from "./terminais_tef.vue?vue&type=style&index=0&id=52d808d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d808d5",
  null
  
)

export default component.exports